import { Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { calcLineaNameContrato, ROUTER_PATHS, useIsMediaQuery } from '@/shared';
import { Contrato } from '@/shared/interfaces';

export type ClienteFibraFormTitleProps = {
  contract: Contrato;
};

const ClienteFibraFormTitle: React.FC<ClienteFibraFormTitleProps> = ({
  contract,
}) => {

  const clientesFibraOpticaReturnUrl =
    ROUTER_PATHS.clientes.fibraOpticaNav;

  const navigate = useNavigate();
  const isMobile = useIsMediaQuery('sm');

  return (
    <Grid item xs={12} container>
      <Grid item xs={12} md={9}>
        <Typography variant="h4" pb={isMobile ? 3 : 6}>
          {calcLineaNameContrato(contract) + ' '}

          <span className="cliente__page--title">
            (#{contract?.numero_referencia})
          </span>
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        md={3}
        container
        justifyContent="flex-end"
        alignItems="flex-start"
      >
        <Button
          onClick={() => navigate(clientesFibraOpticaReturnUrl)}
          variant="outlined"
          sx={{
            py: 1,
            my: 0,
          }}
          size="small"
        >
          REGRESAR
        </Button>
      </Grid>
    </Grid>
  );
};

export default ClienteFibraFormTitle;
